import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class RenewalRateService {
  http = inject(HttpClient);
  featureFlagService = inject(FeatureFlagService);

  /**
   * Gets the base URL for PLPC vehicle API calls.
   * @returns The appropriate base URL based on feature flags
   */
  private getBaseUrl(): string {
    const usePolicyExperienceApi = this.featureFlagService.isEnabled('policycontextapi_migration');
    if (!usePolicyExperienceApi) {
      return env.plpcContextAPI;
    }
    const useAddVehicleV2 = this.featureFlagService.isEnabled('add_vehicle_v2');
    return (useAddVehicleV2 ? env.policyExperienceApiV2 : env.policyExperienceApi) + 'plpcvehicle/';
  }

  public renewalRateAddVehicleFeature(payload: unknown): Observable<VehicleRateRenewalState> {
    const usePolicyExperienceApi = this.featureFlagService.isEnabled('policycontextapi_migration');
    let headers = new HttpHeaders();
    if (!usePolicyExperienceApi && env.applicationTitle === 'MyAccount - INT - 01') {
      headers = headers.set('afi-leg', '01');
    }
    return this.http.post<VehicleRateRenewalState>(this.getBaseUrl() + 'renewal-rate', payload, {
      headers
    });
  }
}

export interface VehicleRateRenewalState {
  renewalRate: string;
  totalCost: number;
  termMonths: number;
  monthlyPremium: number;
  priorCost: number;
  transactionCost: number;
  totalDiscountAmount: number;
}
